import { ROUTES_PATHS } from '@src/constants/routes';
import { ContentEditorMenuItem } from './types';

export const CONTENT_EDITOR_DROPDOWN_CONSTANTS = {
  SESSION_KEYS: {
    CURRENT_USER: 'currentUser',
    CANCEL_POPUP: 'cancelPopup',
    SIMULATION_MODE: 'simulationMode',
  },
  EVENTS: {
    EXIT_PROVIDER_VIEW: 'ExitProviderView',
    DROPDOWN_STATE_CHANGE: 'dropdownStateChange',
    REACT_NAVIGATION: 'reactNavigation',
  },
  ROLES: {
    UHCI_ADMIN: 'UHCI_Admin',
  },
  NAV_DEFAULTS: {
    INDEX: -1,
    SUB_INDEX: -1,
    SELECTED_ROW_INDEX: -1,
    SELECTED_SUB_INDEX: -1,
  },
  POLLING: {
    INTERVAL_MS: 500,
    TIMEOUT_MS: 10000,
  },
  LABEL: 'Content Editor',
};

export const CONTENT_EDITOR_MENU_ITEMS: ContentEditorMenuItem[] = [
  { key: 'faq', label: 'FAQ Documentation', path: ROUTES_PATHS.ContentEditor.FAQ },
  { key: 'knowledgeCenter', label: 'Knowledge Center', path: ROUTES_PATHS.ContentEditor.root },
  { key: 'onboarding', label: 'Onboarding', path: ROUTES_PATHS.ContentEditor.Onboarding },
  { key: 'notification', label: 'Notification Banner Manager', path: ROUTES_PATHS.ContentEditor.Notification },
];
